import { Head, Link } from '@inertiajs/react'
import AppLayout from '@/components/AppLayout'
import PageTitle from '@/components/PageTitle'
import { Button } from '@/components/ui/Button'
import CardForm, { type CardFormData, type CardOptions } from '@/components/cards/CardForm'

interface CardRecord extends Partial<CardFormData> {
  id: string
  cr_name: string
  concept_image_url?: string | null
  design_image_url?: string | null
  cr_image_url?: string | null
  wiki_link?: string
}

interface CardPermissions {
  update: boolean
  write: boolean
  art: boolean
}

function toFormData(card: CardRecord): CardFormData {
  const s = (v: unknown) => (v == null ? '' : String(v))
  return {
    cr_name: card.cr_name,
    name: s(card.name),
    description: s(card.description),
    count: card.count ?? 1,
    arena: card.arena ?? 0,
    rarity: s(card.rarity) || 'common',
    card_type: s(card.card_type) || 'troop',
    transport: s(card.transport),
    target_air: card.target_air ?? false,
    target_ground: card.target_ground ?? false,
    focus: s(card.focus) || 'units',
    range_tiles: s(card.range_tiles),
    speed: s(card.speed),
    hit_speed: s(card.hit_speed),
    first_hit_speed: s(card.first_hit_speed),
    cost: card.cost ?? 0,
    form_size: s(card.form_size),
    concept_image: null,
    design_image: null,
    cr_image: null,
    wiki_link: s(card.wiki_link),
  }
}

export default function CardsShow({ card, options, permissions }: { card: CardRecord; options: CardOptions; permissions: CardPermissions }) {
  const data = toFormData(card)

  return (
    <AppLayout
      header={<PageTitle title="Card Details" subtitle={card.cr_name} />}
      headerActions={
        <div className="flex gap-2">
          {permissions.update && (
            <Button asChild size="sm">
              <Link href={`/cards/${card.id}/edit`}>{permissions.write ? 'Edit' : 'Edit art'}</Link>
            </Button>
          )}
          <Button asChild variant="outline" size="sm">
            <Link href="/cards">Back</Link>
          </Button>
        </div>
      }
    >
      <Head title={card.name || card.cr_name} />
      <div className="max-w-5xl space-y-6">
        <CardForm
          data={data}
          errors={{}}
          setData={() => {}}
          options={options}
          conceptImageUrl={card.concept_image_url}
          designImageUrl={card.design_image_url}
          crImageUrl={card.cr_image_url}
          disabled={true}
        />
      </div>
    </AppLayout>
  )
}
